import React from "react";
import Tooltip from '@mui/material/Tooltip';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import {
    GAMEIFRAME_INTRO_URL_WITHOUT_PARAM,
    GAMEIFRAME_URL_WITHOUT_PARAM,
    INTERVIEWIFRAME_INTRO_URL_WITHOUT_PARAM,
    INTERVIEWIFRAME_URL_WITHOUT_PARAM,
    ASSESSMENTIFRAME_INTRO_URL_WITHOUT_PARAM,
    ASSESSMENTIFRAME_URL_WITHOUT_PARAM
} from '../../Utils/Constants';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DoneIcon from '@mui/icons-material/Done';

export default function MultiActionAreaCard(props) {
    const t = props.t;
    const completed = props.completed;
    const cover = props.cover;
    const link = props.link;
    const navigate = props.navigate;
    const text = props.text;
    const title = props.title;
    const backgroundColor = props.backgroundColor;
    const lightBackgroundColor = props.lightBackgroundColor;
    const comingSoon = props.comingSoon;
    const openInIframe = props.openInIframe;
    const duration = props.duration;
    const level = props.level;
    const interview = props.interview;
    const assessment = props.assessment;
    const game = props.game;
    const gameIFrameUrl = `${GAMEIFRAME_URL_WITHOUT_PARAM}` + props.id;
    const interviewIFrameUrl = `${INTERVIEWIFRAME_URL_WITHOUT_PARAM}` + props.id;
    const assessmentIFrameUrl = `${ASSESSMENTIFRAME_URL_WITHOUT_PARAM}` + props.id;
    const width = props.width;
    const height = props.height;

    const introInterviewUrl = `${INTERVIEWIFRAME_INTRO_URL_WITHOUT_PARAM}` + props.id
    const introGameUrl = `${GAMEIFRAME_INTRO_URL_WITHOUT_PARAM}` + props.id
    const introValutationeUrl = `${ASSESSMENTIFRAME_INTRO_URL_WITHOUT_PARAM}` + props.id

    return (
    !comingSoon ?
    <Tooltip title={text}>
    <ContentCard height={height} width={width} link={link} duration={duration} level={level} completed={completed} navigate={navigate} cover={cover} title={title} backgroundColor={backgroundColor} lightBackgroundColor={lightBackgroundColor}/>
    </Tooltip> :
    openInIframe ?
    <Tooltip title={text}>
    <Link className="lykiocss-unstyled-link" to={interview ? introInterviewUrl : game ? introGameUrl : assessment ? introValutationeUrl : ""}>
    <ContentCard height={height} width={width} completed={completed} cover={cover} duration={duration} level={level} title={title} backgroundColor={backgroundColor} lightBackgroundColor={lightBackgroundColor} />
    </Link>
    </Tooltip>
    :
    <ContentCard height={height} width={width} completed={completed} cover={cover} duration={duration} level={level} title={title ? title : "COMING SOON"} backgroundColor={backgroundColor} lightBackgroundColor={lightBackgroundColor}/>
    );
}


const ContentCard = (props) => {
  const navigate = props.navigate;
  const link = props.link;
  const width = props.width;
  const height = props.height;
  const duration = props.duration;
  const level = props.level;
  const completed = props.completed;
  const linearGradient = `linear-gradient(to right, ${props.backgroundColor}, ${props.lightBackgroundColor})`;
  console.log('linearGradient',linearGradient);
  return (
    <div onClick={()=>{link && navigate(link)}} className={link ? 'hand' : 'nothing'} style={{ width: width ? width :'22rem', height: height ? height : '24rem', background:linearGradient, position: 'relative' }}>
      <img
        src={props.cover}
        alt="Cover image"
        style={{
          width: '100%',
          height: '80%',
          position: 'absolute',
          top: '53%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      />
      <div className="lykiocss-center" style={{ textAlign:'center', paddingTop: '0.1%', marginLeft:'1px', marginRight:'1px', color:'white', fontSize:'17px', fontWeight:'500' }}>
        {props.title ? props.title : 'title'}
      </div>
      <div style={{ position: 'absolute', bottom: '0', left:'0.5em', width: '100%', color:'white', fontSize:'18px', fontWeight:'500' }}>
        <span style={{position:'absolute', right:'325px', bottom:'1px'}}>{completed ? <DoneIcon/> : <></>}</span> 
        <span style={{position:'absolute', right:'115px', bottom:'1px', fontSize:'0.9em'}}>{level && `${level} `}</span>
         <span style={{position:'absolute', right:'43px', bottom:'1px'}}>{duration && `${duration} min`}</span>
      </div>
    </div>
  );
}